import { createFileRoute } from '@tanstack/react-router'
import { AccountingChecksSection } from '../../../features/accounting/books-health-settings-section'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/accounting-checks')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'accounting-checks'),
  component: AccountingChecksSection,
})
